import type { SVGProps } from 'react';
const SvgEsCircle = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={15} height={15} fill="none" viewBox="-1 -1 32 32" {...props}>
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M15 28.929c7.693 0 13.929-6.236 13.929-13.929S22.693 1.071 15 1.071C7.308 1.071 1.071 7.307 1.071 15S7.307 28.929 15 28.929"
    />
    <g fill="currentColor">
      <path d="M8 10.028v9.52h5.76v-2.027h-3.28v-1.893h2.96v-1.947h-2.96v-1.626h3.16v-2.027zM20.138 12.774h2.32q0-1.533-.733-2.227-.72-.706-2.347-.706-1.573 0-2.347.76-.773.76-.773 2.213 0 .84.28 1.36.293.52.72.84.44.32.947.52t.933.4q.44.187.72.467.293.266.293.733 0 .387-.213.653-.2.267-.587.267-.36 0-.586-.24-.227-.253-.227-.867v-.226h-2.4v.333q0 .747.213 1.253.214.507.614.827.413.307 1 .427.6.133 1.373.133 1.64 0 2.507-.68.866-.693.866-2.213 0-.867-.306-1.4-.294-.547-.747-.88-.453-.334-.973-.534-.52-.213-.974-.413t-.76-.467q-.293-.28-.293-.746 0-.32.187-.574.186-.266.586-.266.36 0 .534.306.173.294.173.72z" />
    </g>
  </svg>
);
export default SvgEsCircle;
